import { render, staticRenderFns } from "./DialogProductImage.vue?vue&type=template&id=acdfc480&"
import script from "./DialogProductImage.vue?vue&type=script&lang=js&"
export * from "./DialogProductImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports